import React from 'react';
import PropTypes from 'prop-types';

import { Select, Flex, Label } from '@sopranodesign/pulse-components';

import ApiKey from './ApiKey';
import BasicAuth from './BasicAuth';
import BearerToken from './BearerToken';
import NoAuth from './NoAuth';
import OAuth2 from './OAuth2';
import { types } from '../../../hooks/useAuth';

const components = {
  'API Key': ApiKey,
  'Basic Auth': BasicAuth,
  'Bearer Token': BearerToken,
  'No Auth': NoAuth,
  OAuth2
};

const options = types.map(type => ({ value: type, label: type }));

const Auth = ({ type, handleChangeType, ...rest }) => {
  const Component = components[type] || NoAuth;

  return (
    <Flex col>
      <Flex col style={{ maxWidth: '16rem' }} mb>
        <Label htmlFor="auth-select">Type</Label>
        <Select
          id="auth-select"
          options={options}
          value={options.find(option => option.value === type)}
          onChange={handleChangeType}
        />
      </Flex>
      <Flex growChildren wrap="true" xSpace gap>
        <Component {...rest} />
      </Flex>
    </Flex>
  );
};

Auth.propTypes = {
  type: PropTypes.oneOf(types),
  handleChangeType: PropTypes.func.isRequired
};

export default Auth;
